class AgoraCallTimeLeft {
  usedCallTime: number;

  constructor(params?: AgoraCallTimeLeft) {
    this.usedCallTime = params?.usedCallTime || -1;
  }
}

export { AgoraCallTimeLeft };
